import React from 'react';
import { tinaField } from 'tinacms/dist/react';
import type { Block } from '@/cms/types';

export function PageTitle(
  data: Block & {
    title: string;
  },
): React.JSX.Element {
  const { title } = data;

  return (
    <section>
      <h1
        className='container max-w-screen-lg my-7 text-5xl text-white text-center font-extrabold leading-none tracking-tight sm:text-6xl sm:p-8'
        data-tina-field={tinaField(data, 'title')}>
        {title}
      </h1>
    </section>
  );
}
